export default __webpack_public_path__ + "static/media/Star.97c15b46.svg";